import { useCallback } from "react";

export function useLocalStorageSync(keys) {
  // keys argument is not actively used here, but kept for potential future use
  const getItem = useCallback((key, defaultValue) => {
    try {
      const item = window.localStorage.getItem(key);
      if (item !== null) {
        const parsed = JSON.parse(item);
        if (process.env.NODE_ENV === "development") {
          console.log(
            `[useLocalStorageSync] Loaded ${key} from localStorage:`,
            parsed
          );
        }
        return parsed;
      }
      if (process.env.NODE_ENV === "development") {
        console.log(
          `[useLocalStorageSync] No ${key} in localStorage, using default:`,
          defaultValue
        );
      }
      return defaultValue;
    } catch (error) {
      console.error(
        `[useLocalStorageSync] Error reading ${key} from localStorage:`,
        error
      );
      return defaultValue;
    }
  }, []);

  const setItem = useCallback((key, value) => {
    try {
      if (value === undefined || value === null) {
        if (process.env.NODE_ENV === "development") {
          console.warn(
            `[useLocalStorageSync] Attempted to save undefined/null for ${key}, skipping.`
          );
        }
        return;
      }
      window.localStorage.setItem(key, JSON.stringify(value));
      if (process.env.NODE_ENV === "development") {
        console.log(
          `[useLocalStorageSync] Saved ${key} to localStorage:`,
          value
        );
      }
    } catch (error) {
      console.error(
        `[useLocalStorageSync] Error saving ${key} to localStorage:`,
        error
      );
    }
  }, []);

  return { getItem, setItem };
}
